import * as React from 'react';
import styled, { css } from 'styled-components';
import { rem } from 'polished';

export enum IconType {
  phone = 'phone',
  email = 'email',
  newCart = 'newCart',
  cardView = 'cardView',
  listView = 'listView',
  user = 'user',
  cart = 'cart',
  listMenu = 'listMenu',
  search = 'search',
  close = 'close',
  back = 'back',
  rightArrow = 'rightArrow',
  upload = 'upload',
  success = 'success',
  error = 'error',
  document = 'document',
  refresh = 'refresh',
  paid = 'paid',
  time = 'time',
  inwork = 'inwork',
  checked = 'checked',
  newAddress = 'newAddress',
  trash = 'trash',
  minus = 'minus',
  plus = 'plus',
  downArrow = 'downArrow',
  cartDone = 'cartDone',
  emptyCart = 'emptyCart',
  finishedOrder = 'finishedOrder',
  filterBottomArrow = 'filterBottomArrow',
  backFilter = 'backFilter',
  resetFilter = 'resetFilter',
  home = 'home',
  person = 'person',
  desc = 'desc',
  instructions = 'instructions',
  healing = 'healing',
  star = 'star',
  filter = 'filter',
  category = 'category',
  cartLarge = 'cartLarge',
  download = 'download',
  x = 'x',
  scroll = 'scroll',
  freeDel = 'freeDel',
  login = 'login',
}

interface Props {
  icon: IconType;
  className?: string;
  viewBox?: string;
  fill?: string;
  title?: string;
  alt?: string;
  cursor?: string;
  marginLeft?: number;
  marginRight?: number;
  height?: number;
  width?: number;
  onClick?: any;
  rotate?: number;
}

const icons = {
  login: () => (
    <path
      d="M12.1,6.6V4.7c0-2.3-1.8-4.1-4.1-4.1S3.9,2.4,3.9,4.7v1.9c-1.5,0-2.7,1.3-2.7,2.7v3.3c0,1.5,1.2,2.8,2.8,2.8h8
	c1.5,0,2.8-1.2,2.8-2.8V9.3C14.8,7.8,13.6,6.6,12.1,6.6z M8,2.1c1.4,0,2.6,1.2,2.6,2.6v1.9H5.4V4.7C5.4,3.2,6.6,2.1,8,2.1z
	 M13.3,12.7c0,0.7-0.6,1.3-1.3,1.3H4c-0.7,0-1.3-0.6-1.3-1.3V9.3c0-0.7,0.6-1.3,1.3-1.3h8c0.7,0,1.3,0.6,1.3,1.3V12.7z"
    />
  ),
  scroll: () => (
    <path
      d="M25.7,6.1l-4,4c-0.2,0.2-0.5,0.3-0.7,0.3s-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l2.3-2.3H3.4l2.3,2.3c0.4,0.4,0.4,1,0,1.4
	c-0.2,0.2-0.5,0.3-0.7,0.3s-0.5-0.1-0.7-0.3l-4-4c-0.4-0.4-0.4-1,0-1.4l4-4c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L3.4,4.4h19.2l-2.3-2.3
	c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l4,4C26.1,5.1,26.1,5.7,25.7,6.1z"
    />
  ),
  x: () => (
    <path
      d="M9.7,8.3c0.4,0.4,0.4,1,0,1.4C9.5,9.9,9.3,10,9,10S8.5,9.9,8.3,9.7L6,7.4L3.7,9.7C3.5,9.9,3.3,10,3,10S2.5,9.9,2.3,9.7
	c-0.4-0.4-0.4-1,0-1.4L4.6,6L2.3,3.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0L6,4.6l2.3-2.3c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L7.4,6
	L9.7,8.3z"
    />
  ),
  download: () => (
    <path
      d="M14.8,10v2.7c0,1.1-0.9,2.1-2.1,2.1H3.3c-1.1,0-2.1-0.9-2.1-2.1V10c0-0.4,0.3-0.8,0.8-0.8S2.8,9.6,2.8,10v2.7
	c0,0.3,0.3,0.6,0.6,0.6h9.3c0.3,0,0.6-0.3,0.6-0.6V10c0-0.4,0.3-0.8,0.8-0.8S14.8,9.6,14.8,10z M7.5,10.5c0.1,0.1,0.2,0.1,0.2,0.2
	c0.1,0,0.2,0.1,0.3,0.1s0.2,0,0.3-0.1c0.1,0,0.2-0.1,0.2-0.2l3.3-3.3c0.3-0.3,0.3-0.8,0-1.1s-0.8-0.3-1.1,0L8.8,8.2V2
	c0-0.4-0.3-0.8-0.8-0.8S7.3,1.6,7.3,2v6.2L5.2,6.1c-0.3-0.3-0.8-0.3-1.1,0s-0.3,0.8,0,1.1L7.5,10.5z"
    />
  ),
  phone: () => (
    <path
      d="M12.9,15.7c-0.1,0-0.1,0-0.2,0c-2.2-0.2-4.3-1-6.1-2.2C5,12.5,3.5,11,2.4,9.3C1.2,7.5,0.5,5.4,0.3,3.2C0.2,2,1,1,2.1,0.9
	c0.1,0,0.1,0,0.2,0h2c1-0.1,1.9,0.8,2.1,1.8c0.1,0.6,0.2,1.2,0.4,1.7C7.1,5.2,6.9,6,6.4,6.6L5.9,7.1C6.7,8.2,7.7,9.2,8.9,10l0.4-0.4
	c0.6-0.6,1.4-0.8,2.2-0.5c0.6,0.2,1.1,0.3,1.7,0.4c1.1,0.1,1.8,1.1,1.8,2.1c0,0,0,0,0,0.1v1.9c0,0.6-0.2,1.1-0.6,1.5
	C14,15.5,13.5,15.7,12.9,15.7z M4.3,2.4C4.3,2.4,4.3,2.4,4.3,2.4h-2C2,2.4,1.7,2.7,1.8,3.1C2,5,2.6,6.9,3.7,8.5
	c1,1.5,2.3,2.8,3.8,3.8c1.6,1.1,3.5,1.7,5.4,1.9c0.2,0,0.3-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.4v-2c0,0,0,0,0-0.1
	c0-0.3-0.2-0.5-0.5-0.5c-0.7-0.1-1.4-0.3-2-0.5c-0.2-0.1-0.5,0-0.6,0.1l-0.8,0.8c-0.2,0.2-0.6,0.3-0.9,0.1c-1.8-1-3.3-2.5-4.3-4.3
	C4.2,7,4.2,6.6,4.5,6.4l0.8-0.8c0.2-0.2,0.2-0.4,0.1-0.6C5.2,4.3,5,3.6,4.9,2.9C4.9,2.6,4.6,2.4,4.3,2.4z M12.3,7
	c-0.4,0-0.7-0.2-0.7-0.6c-0.2-1-1-1.8-2-2C9.1,4.3,8.8,3.9,8.9,3.5C9,3.1,9.4,2.9,9.8,2.9c1.6,0.3,2.9,1.6,3.2,3.2
	C13.1,6.6,12.8,7,12.4,7C12.4,7,12.3,7,12.3,7z M14.9,7c-0.4,0-0.7-0.3-0.7-0.7C13.9,3.9,12,2,9.5,1.7c-0.4,0-0.7-0.4-0.7-0.8
	c0-0.4,0.4-0.7,0.8-0.7c3.2,0.4,5.6,2.8,6,6C15.7,6.6,15.4,7,14.9,7C15,7,15,7,14.9,7z"
    />
  ),

  email: () => (
    <path
      d="M8,0.6C3.9,0.6,0.6,3.9,0.6,8s3.3,7.4,7.4,7.4c1.6,0,3.2-0.5,4.5-1.5c0.3-0.3,0.4-0.7,0.1-1.1c-0.3-0.3-0.7-0.4-1.1-0.1
	c-1,0.8-2.3,1.2-3.6,1.2c-3.3,0-5.9-2.7-5.9-5.9c0-3.3,2.7-5.9,5.9-5.9c3.3,0,5.9,2.7,5.9,5.9v0.7c0,0.7-0.6,1.3-1.3,1.3
	s-1.3-0.6-1.3-1.3V5.3c0-0.4-0.3-0.8-0.8-0.8c-0.4,0-0.7,0.3-0.7,0.6C9.4,4.8,8.7,4.6,8,4.6C6.1,4.6,4.6,6.1,4.6,8
	c0,1.9,1.5,3.4,3.4,3.4c1,0,1.9-0.4,2.5-1.1c0.5,0.7,1.3,1.1,2.2,1.1c1.5,0,2.8-1.2,2.8-2.8V8C15.4,3.9,12.1,0.6,8,0.6z M8,9.9
	C6.9,9.9,6.1,9.1,6.1,8c0-1.1,0.9-1.9,1.9-1.9c1.1,0,1.9,0.9,1.9,1.9C9.9,9.1,9.1,9.9,8,9.9z"
    />
  ),

  newCart: () => (
    <path
      d="M9,24c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S10.1,24,9,24z M22,22c0-1.1-0.9-2-2-2s-2,0.9-2,2s0.9,2,2,2S22,23.1,22,22z
	 M9.7,18h9.7c1.5,0,2.7-1,3-2.4L24,7.2c0.1-0.3,0-0.6-0.2-0.8C23.6,6.1,23.3,6,23,6H6.8L6,1.8C5.9,1.3,5.5,1,5,1H1C0.4,1,0,1.4,0,2
	s0.4,1,1,1h3.2L5,7.2c0,0,0,0.1,0,0.1l1.7,8.3C7,17,8.2,18,9.7,18C9.6,18,9.7,18,9.7,18z M21.8,8l-1.4,7.2c-0.1,0.5-0.5,0.8-1,0.8
	H9.7c-0.5,0-0.9-0.3-1-0.8L7.2,8H21.8z"
    />
  ),
  cardView: () => (
    <path
      d="M8,0H2C0.9,0,0,0.9,0,2v6c0,1.1,0.9,2,2,2h6c1.1,0,2-0.9,2-2V2C10,0.9,9.1,0,8,0z M8,8H2l0-6h0h6V8z M8,12H2
	c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h6c1.1,0,2-0.9,2-2v-6C10,12.9,9.1,12,8,12z M8,20H2l0-6h0h6V20z M20,0h-6c-1.1,0-2,0.9-2,2v6
	c0,1.1,0.9,2,2,2h6c1.1,0,2-0.9,2-2V2C22,0.9,21.1,0,20,0z M20,8h-6l0-6h0h6V8z M20,12h-6c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h6
	c1.1,0,2-0.9,2-2v-6C22,12.9,21.1,12,20,12z M20,20h-6l0-6h0h6V20z"
    />
  ),
  listView: () => (
    <path
      d="M0,1c0-0.6,0.4-1,1-1h20c0.6,0,1,0.4,1,1s-0.4,1-1,1H1C0.4,2,0,1.6,0,1z M21,8H1C0.4,8,0,8.4,0,9s0.4,1,1,1h20
	c0.6,0,1-0.4,1-1S21.6,8,21,8z M21,16H1c-0.6,0-1,0.4-1,1s0.4,1,1,1h20c0.6,0,1-0.4,1-1S21.6,16,21,16z"
    />
  ),
  user: () => (
    <path
      d="M23,18.6v2.8c0,1-0.4,2.1-1.4,2.1h-19c-1.1,0-1.6-1.6-1.6-2.1v-2.8c0-3,2.9-5.5,7-6.5c-1.5-1.2-2.5-3-2.5-5.1
	c0-3.6,2.9-6.5,6.5-6.5s6.5,2.9,6.5,6.5c0,2.1-1,3.9-2.5,5.1C20.1,13.1,23,15.6,23,18.6z M7.5,7c0,2.5,2,4.5,4.5,4.5s4.5-2,4.5-4.5
	s-2-4.5-4.5-4.5S7.5,4.5,7.5,7z M21,18.6c0-2.7-4.1-5-9-5c-4.9,0-9,2.3-9,5v2.8c0,0,0,0,0,0.1H21c0,0,0-0.1,0-0.1V18.6z"
    />
  ),
  cart: () => (
    <path
      d="M20.1,5.9H17l0-0.4c0-0.3,0-0.6,0-0.8c-0.1-1.3-0.7-2.5-1.8-3.4c-1-0.9-2.3-1.3-3.7-1.2C8.8,0.2,6.8,2.7,7,5.4
	v0.5H3.9c-1,0-1.4,0.7-1.4,1.4l1.3,13.6c0.1,1.7,1.6,3.1,3.3,3.1c0.1,0,0.2,0,0.2,0c0.6,0,9.2,0,9.3,0c0.9,0,1.7-0.2,2.4-0.8
	c0.7-0.6,1.1-1.4,1.1-2.3l1.3-13.6C21.5,6.5,20.9,5.9,20.1,5.9z M9,5.3C8.9,3.6,10.1,2.2,11.7,2c0.8-0.1,1.6,0.2,2.2,0.7
	c0.6,0.5,1,1.2,1.1,2c0,0.2,0,0.3,0,0.6v0.5H9L9,5.3z M18.2,20.6c0,0.4-0.2,0.7-0.4,0.9c-0.3,0.2-0.6,0.4-1,0.3c-0.1,0-0.1,0-9.5,0
	c0,0-0.1,0-0.1,0c-0.7,0.1-1.4-0.5-1.5-1.3L4.6,7.9h14.9L18.2,20.6z"
    />
  ),
  listMenu: () => (
    <path
      id="Icon"
      transform="translate(620.5 361.5)"
      d="M-600-354.5h-17c-0.6,0-1-0.4-1-1s0.4-1,1-1h17c0.6,0,1,0.4,1,1
    S-599.4-354.5-600-354.5z M-599-349.5c0-0.6-0.4-1-1-1h-17c-0.6,0-1,0.4-1,1s0.4,1,1,1h17C-599.4-348.5-599-348.9-599-349.5z
     M-599-343.5c0-0.6-0.4-1-1-1h-17c-0.6,0-1,0.4-1,1s0.4,1,1,1h17C-599.4-342.5-599-342.9-599-343.5z"
    />
  ),
  search: () => (
    <path
      d="M21.7,20.3L18,16.6c1.2-1.5,2-3.5,2-5.6c0-5-4-9-9-9c-5,0-9,4-9,9c0,5,4,9,9,9c2.1,0,4.1-0.7,5.6-2l3.7,3.7
	c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3C22.1,21.3,22.1,20.7,21.7,20.3z M4,11c0-3.9,3.1-7,7-7c3.9,0,7,3.1,7,7
	c0,1.9-0.8,3.7-2,4.9c0,0,0,0,0,0s0,0,0,0c-1.3,1.3-3,2-4.9,2C7.1,18,4,14.9,4,11z"
    />
  ),
  close: () => (
    <>
      <defs>
        <style>{`.a{fill:none;}`}</style>
      </defs>
      <g transform="translate(-15 -22)">
        <g transform="translate(-251 -4515)">
          <rect
            className="a"
            width="28"
            height="28"
            transform="translate(266 4537)"
          />
        </g>
        <path
          d="M-2056.736,595.678l-7.071-7.071-7.072,7.071a1,1,0,0,1-1.413,0,1,1,0,0,1,0-1.415l7.071-7.071-7.071-7.071a1,1,0,0,1,0-1.415,1,1,0,0,1,1.413,0l7.072,7.071,7.071-7.071a1,1,0,0,1,1.415,0,1,1,0,0,1,0,1.415l-7.072,7.071,7.072,7.072a1,1,0,0,1,0,1.413,1,1,0,0,1-.708.293A.994.994,0,0,1-2056.736,595.678Z"
          transform="translate(2092.807 -551.192)"
        />
      </g>
    </>
  ),
  back: () => <path id="arrow" d="M5.5,12,0,6,5.5,0,7,1.4,2.7,6,7,10.6Z" />,
  rightArrow: () => (
    <path
      d="M4.5,10C4.2,10,4,9.9,3.8,9.7c-0.4-0.4-0.4-1,0-1.4L6.1,6L3.8,3.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l3,3
	c0.4,0.4,0.4,1,0,1.4l-3,3C5,9.9,4.8,10,4.5,10z"
    />
  ),
  upload: () => (
    <path
      d="M22,16.8v5c0,0.6-0.4,1-1,1H3c-0.6,0-1-0.4-1-1v-5c0-0.6,0.4-1,1-1s1,0.4,1,1v4h16v-4c0-0.6,0.4-1,1-1S22,16.2,22,16.8z
	 M5.3,10c0.3,0,0.5-0.1,0.7-0.3l5-4.9l0,11.6c0,0.6,0.4,1,1,1c0,0,0,0,0,0c0.6,0,1-0.5,1-1l0-11.6l5.1,4.9c0.4,0.4,1,0.4,1.4,0
	c0.4-0.4,0.4-1,0-1.4l-6.8-6.5c-0.1-0.1-0.2-0.1-0.3-0.2c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3-0.1c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.3,0
	c0,0,0,0-0.1,0c0,0,0,0,0,0c-0.1,0-0.2,0.1-0.3,0.2c0,0,0,0,0,0L4.6,8.3c-0.4,0.4-0.4,1,0,1.4C4.7,9.9,5,10,5.3,10z"
    />
  ),
  success: () => (
    <path
      d="M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M13,17h-2v-6h2V17z M13,9h-2V7h2
	V9z"
    />
  ),
  error: () => (
    <path
      d="M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M13,17h-2v-6h2V17z M13,9h-2V7h2
	V9z"
    />
  ),
  document: () => (
    <path d="M14,2H6C4.9,2,4,2.9,4,4l0,16c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2V8L14,2z M6,20V4h7v5h5v11H6z" />
  ),
  refresh: () => (
    <path
      d="M17.6,6.3c-3.1-3.1-8.2-3.1-11.3,0s-3.1,8.2,0,11.3s8.2,3.1,11.3,0c1-1,1.7-2.3,2.1-3.7h-2.1c-1.1,3.1-4.5,4.8-7.7,3.7
	S5.2,13.1,6.3,10C7.2,7.6,9.5,6,12,6c1.6,0,3.1,0.6,4.2,1.8L13,11h7V4L17.6,6.3z"
    />
  ),
  paid: () => (
    <path
      d="M12,22.5C6.2,22.5,1.5,17.8,1.5,12C1.5,6.2,6.2,1.5,12,1.5c5.8,0,10.5,4.7,10.5,10.5C22.5,17.8,17.8,22.5,12,22.5z M12,3.5
	c-4.7,0-8.5,3.8-8.5,8.5c0,4.7,3.8,8.5,8.5,8.5c4.7,0,8.5-3.8,8.5-8.5C20.5,7.3,16.7,3.5,12,3.5z M11.5,15.2l5.3-5
	c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0l-4.6,4.3l-2-2.1c-0.4-0.4-1-0.4-1.4,0c-0.4,0.4-0.4,1,0,1.4l2.7,2.8
	c0.2,0.2,0.5,0.3,0.7,0.3C11,15.5,11.3,15.4,11.5,15.2z"
    />
  ),
  time: () => (
    <path
      d="M12,22.5C6.2,22.5,1.5,17.8,1.5,12C1.5,6.2,6.2,1.5,12,1.5c5.8,0,10.5,4.7,10.5,10.5C22.5,17.8,17.8,22.5,12,22.5z M12,3.5
	c-4.7,0-8.5,3.8-8.5,8.5c0,4.7,3.8,8.5,8.5,8.5c4.7,0,8.5-3.8,8.5-8.5C20.5,7.3,16.7,3.5,12,3.5z M16.5,14.5c0.2-0.5,0-1.1-0.4-1.3
	l-3.2-1.6v-5c0-0.6-0.4-1-1-1s-1,0.4-1,1v5.6c0,0.4,0.2,0.7,0.6,0.9l3.7,1.9c0.1,0.1,0.3,0.1,0.4,0.1C16,15,16.3,14.8,16.5,14.5z"
    />
  ),
  inwork: () => (
    <path
      d="M17,4h-1c0-1.1-0.9-2-2-2h-4C8.9,2,8,2.9,8,4H7C5.3,4,4,5.3,4,7v12c0,1.7,1.3,3,3,3h10c1.7,0,3-1.3,3-3V7
	C20,5.3,18.7,4,17,4z M10,4h4v2h-4V4L10,4z M18,19c0,0.6-0.4,1-1,1H7c-0.6,0-1-0.4-1-1V7c0-0.6,0.4-1,1-1h1c0,1.1,0.9,2,2,2h4
	c1.1,0,2-0.9,2-2h1c0.6,0,1,0.4,1,1V19z"
    />
  ),
  checked: () => (
    <path
      d="M6,12.3c-0.3,0-0.5-0.1-0.7-0.3L2,8.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0L6,9.9l6.6-6.6c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4
	L6.7,12C6.5,12.2,6.3,12.3,6,12.3z"
    />
  ),
  newAddress: () => (
    <path
      d="M21.5,24h-6.2c-0.6,0-1-0.4-1-1v-5.8H9.7V23c0,0.6-0.4,1-1,1H2.5C1.7,24,1,23.4,1,22.6v-13C1,9.3,1.1,9,1.3,8.8l10-8.6
	l1.3,1.5L3,10.1V22h4.7v-5.8c0-0.6,0.4-1,1-1h6.7c0.6,0,1,0.4,1,1V22H21V9.8h2v12.8C23,23.4,22.3,24,21.5,24z M20,8V5h3V3h-3V0h-2v3
	h-3v2h3v3H20z"
    />
  ),
  trash: () => (
    <path
      d="M14,3.3h-2.6V2.7c0-1.1-0.9-2.1-2.1-2.1H6.7c-1.1,0-2.1,0.9-2.1,2.1v0.6H2C1.6,3.3,1.3,3.6,1.3,4S1.6,4.8,2,4.8h0.6v8.6
	c0,1.1,0.9,2.1,2.1,2.1h6.7c1.1,0,2.1-0.9,2.1-2.1V4.8H14c0.4,0,0.8-0.3,0.8-0.8S14.4,3.3,14,3.3z M6.1,2.7c0-0.3,0.3-0.6,0.6-0.6
	h2.7c0.3,0,0.6,0.3,0.6,0.6v0.6H6.1V2.7z M11.9,13.3c0,0.3-0.3,0.6-0.6,0.6H4.7c-0.3,0-0.6-0.3-0.6-0.6V4.8h7.8V13.3z M7.4,7.3v4
	c0,0.4-0.3,0.8-0.8,0.8s-0.8-0.3-0.8-0.8v-4c0-0.4,0.3-0.8,0.8-0.8S7.4,6.9,7.4,7.3z M10.1,7.3v4c0,0.4-0.3,0.8-0.8,0.8
	s-0.8-0.3-0.8-0.8v-4c0-0.4,0.3-0.8,0.8-0.8S10.1,6.9,10.1,7.3z"
    />
  ),
  minus: () => <path d="M8,0v2H0V0H8z" />,
  plus: () => <path d="M3,8V5H0V3h3V0h2v3h3v2H5v3H3z" />,
  downArrow: () => (
    <path d="M19.3,16.7L12,9.4l-7.3,7.3l-1.4-1.4L12,6.6l8.7,8.7L19.3,16.7z" />
  ),
  cartDone: () => (
    <>
      <defs>
        <style>
          {` .cls-1 {
        fill: none;
      }

      .cls-2, .cls-4 {
        fill: #2DCC8D;
      }

      .cls-3, .cls-4 {
        stroke: none;
      }`}
        </style>
      </defs>
      <g id="done" transform="translate(-938 -394)">
        <g
          id="Path_16"
          data-name="Path 16"
          className="cls-1"
          transform="translate(938 394)"
        >
          <path
            className="cls-3"
            d="M22.5,0A22.5,22.5,0,1,1,0,22.5,22.5,22.5,0,0,1,22.5,0Z"
          />
          <path
            className="cls-4"
            d="M 22.5 43 C 25.26836013793945 43 27.95285987854004 42.45825958251953 30.47891044616699 41.38983154296875 C 32.9197998046875 40.357421875 35.11235809326172 38.87902069091797 36.99568939208984 36.99568939208984 C 38.87902069091797 35.11235809326172 40.357421875 32.9197998046875 41.38983154296875 30.47891044616699 C 42.45825958251953 27.95285987854004 43 25.26836013793945 43 22.5 C 43 19.73163986206055 42.45825958251953 17.04714012145996 41.38983154296875 14.52108955383301 C 40.357421875 12.0802001953125 38.87902069091797 9.887639999389648 36.99568939208984 8.00430965423584 C 35.11235809326172 6.120979785919189 32.9197998046875 4.642580032348633 30.47891044616699 3.610169887542725 C 27.95285987854004 2.541739940643311 25.26836013793945 2 22.5 2 C 19.73163986206055 2 17.04714012145996 2.541739940643311 14.52108955383301 3.610169887542725 C 12.0802001953125 4.642580032348633 9.887639999389648 6.120979785919189 8.00430965423584 8.00430965423584 C 6.120979785919189 9.887639999389648 4.642580032348633 12.0802001953125 3.610169887542725 14.52108955383301 C 2.541739940643311 17.04714012145996 2 19.73163986206055 2 22.5 C 2 25.26836013793945 2.541739940643311 27.95285987854004 3.610169887542725 30.47891044616699 C 4.642580032348633 32.9197998046875 6.120979785919189 35.11235809326172 8.00430965423584 36.99568939208984 C 9.887639999389648 38.87902069091797 12.0802001953125 40.357421875 14.52108955383301 41.38983154296875 C 17.04714012145996 42.45825958251953 19.73163986206055 43 22.5 43 M 22.5 45 C 10.07359027862549 45 -3.552713678800501e-15 34.92641067504883 -3.552713678800501e-15 22.5 C -3.552713678800501e-15 10.07359027862549 10.07359027862549 -3.552713678800501e-15 22.5 -3.552713678800501e-15 C 34.92641067504883 -3.552713678800501e-15 45 10.07359027862549 45 22.5 C 45 34.92641067504883 34.92641067504883 45 22.5 45 Z"
          />
        </g>
        <path
          id="Path_15"
          data-name="Path 15"
          className="cls-2"
          d="M4.1,7.9a.908.908,0,0,1-.7-.3L.3,4.4A.967.967,0,0,1,.3,3,.967.967,0,0,1,1.7,3L4.1,5.4,9.3.2a.967.967,0,0,1,1.4,0,.967.967,0,0,1,0,1.4l-5.9,6A.779.779,0,0,1,4.1,7.9Z"
          transform="translate(956 413.1)"
        />
      </g>
    </>
  ),
  emptyCart: () => (
    <path
      d="M31,23.4L29.6,22L24,27.6L18.4,22L17,23.4l5.6,5.6L17,34.6l1.4,1.4l5.6-5.6l5.6,5.6l1.4-1.4L25.4,29L31,23.4z
  M40.2,12.8H33v-2C33,5.3,29,1,24,1s-9,4.3-9,9.7v2H7.9c-1.3,0-1.9,0.8-1.8,1.7l2.5,26.9c0,3.1,2.6,5.4,6.1,5.4h18.7
 c3.5,0,6.1-2.3,6.1-5.3l2.6-27C42,13.5,41.2,12.8,40.2,12.8z M17,10.7C17,6.4,20.1,3,24,3c3.9,0,7,3.4,7,7.7v2H17V10.7z M37.5,41.4
 c0,1.9-1.8,3.4-4.1,3.4H14.6c-2.3,0-4.1-1.5-4.1-3.5L8,14.8l31.9,0L37.5,41.4z"
    />
  ),
  finishedOrder: () => (
    <path
      d="M24,44C13,44,4,35,4,24C4,13,13,4,24,4c11,0,20,9,20,20C44,35,35,44,24,44z M24,6C14.1,6,6,14.1,6,24
	c0,9.9,8.1,18,18,18c9.9,0,18-8.1,18-18C42,14.1,33.9,6,24,6z M22.2,29.6l10.6-10c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0
	l-9.9,9.3l-4.7-4.8c-0.4-0.4-1-0.4-1.4,0c-0.4,0.4-0.4,1,0,1.4l5.4,5.5c0.2,0.2,0.5,0.3,0.7,0.3C21.8,29.9,22,29.8,22.2,29.6z"
    />
  ),

  filterBottomArrow: () => (
    <path d="M4,5a.908.908,0,0,1-.7-.3l-3-3A.967.967,0,0,1,.3.3.967.967,0,0,1,1.7.3L4,2.6,6.3.3A.967.967,0,0,1,7.7.3a.967.967,0,0,1,0,1.4l-3,3A.908.908,0,0,1,4,5Z" />
  ),

  backFilter: () => (
    <path
      d="M15,19c-0.3,0-0.5-0.1-0.7-0.3l-6-6c-0.4-0.4-0.4-1,0-1.4l6-6c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L10.4,12l5.3,5.3
	c0.4,0.4,0.4,1,0,1.4C15.5,18.9,15.3,19,15,19z"
    />
  ),

  resetFilter: () => (
    <path
      d="M18.7,17.3c0.4,0.4,0.4,1,0,1.4C18.5,18.9,18.3,19,18,19s-0.5-0.1-0.7-0.3L12,13.4l-5.3,5.3
	C6.5,18.9,6.3,19,6,19s-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l5.3-5.3L5.3,6.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l5.3,5.3l5.3-5.3
	c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L13.4,12L18.7,17.3z"
    />
  ),

  home: () => (
    <path
      d="M2.2,15.8c-0.2,0-0.5-0.1-0.6-0.3c-0.2-0.2-0.3-0.4-0.3-0.7l0-8.3c0-0.2,0.1-0.4,0.2-0.6l6-5.5
	c0.3-0.3,0.7-0.3,1,0l6,5.6c0.2,0.1,0.2,0.3,0.2,0.5v8.1c0,0,0,0.1,0,0.1c-0.1,0.6-0.6,1-1.1,0.9l-3.6,0c-0.4,0-0.8-0.3-0.8-0.8
	v-3.6H6.8V15c0,0.4-0.3,0.8-0.8,0.8L2.2,15.8C2.3,15.8,2.3,15.8,2.2,15.8z M2.3,14.3C2.3,14.3,2.2,14.3,2.3,14.3L2.3,14.3
	C2.3,14.3,2.3,14.3,2.3,14.3z M2.8,6.8v7.4l2.5,0v-3.6c0-0.4,0.3-0.8,0.8-0.8h4c0.4,0,0.8,0.3,0.8,0.8v3.6h2.5l0-7.3L8,2L2.8,6.8z
	 M13.6,14.3L13.6,14.3C13.7,14.2,13.7,14.2,13.6,14.3z"
    />
  ),

  person: () => (
    <path
      d="M23,18.6v2.8c0,1-0.4,2.1-1.4,2.1h-19c-1.1,0-1.6-1.6-1.6-2.1v-2.8c0-3,2.9-5.5,7-6.5c-1.5-1.2-2.5-3-2.5-5.1
	c0-3.6,2.9-6.5,6.5-6.5s6.5,2.9,6.5,6.5c0,2.1-1,3.9-2.5,5.1C20.1,13.1,23,15.6,23,18.6z M7.5,7c0,2.5,2,4.5,4.5,4.5s4.5-2,4.5-4.5
	s-2-4.5-4.5-4.5S7.5,4.5,7.5,7z M21,18.6c0-2.7-4.1-5-9-5c-4.9,0-9,2.3-9,5v2.8c0,0,0,0,0,0.1H21c0,0,0-0.1,0-0.1V18.6z"
    />
  ),

  desc: () => (
    <path
      d="M11.3,8.8H2C1.6,8.8,1.3,8.4,1.3,8S1.6,7.3,2,7.3h9.3c0.4,0,0.8,0.3,0.8,0.8S11.7,8.8,11.3,8.8z M14.8,3.3
	c0-0.4-0.3-0.8-0.8-0.8H2c-0.4,0-0.8,0.3-0.8,0.8S1.6,4.1,2,4.1h12C14.4,4.1,14.8,3.7,14.8,3.3z M14.8,12.7c0-0.4-0.3-0.8-0.8-0.8H2
	c-0.4,0-0.8,0.3-0.8,0.8s0.3,0.8,0.8,0.8h12C14.4,13.4,14.8,13.1,14.8,12.7z"
    />
  ),

  instructions: () => (
    <path
      d="M14,5.7c0-0.1-0.1-0.2-0.2-0.2L9.2,0.8C9.1,0.7,9,0.7,9,0.6c-0.1,0-0.2-0.1-0.3-0.1H4c-1.1,0-2.1,0.9-2.1,2.1v10.7
	c0,1.1,0.9,2.1,2.1,2.1h8c0,0,0,0,0,0c0.6,0,1.1-0.2,1.5-0.6c0.4-0.4,0.6-0.9,0.6-1.5V6C14.1,5.9,14.1,5.8,14,5.7z M9.4,3.1l2.1,2.1
	H9.4V3.1z M12,13.9L12,13.9H4c-0.3,0-0.6-0.3-0.6-0.6V2.7c0-0.3,0.3-0.6,0.6-0.6h3.9V6c0,0.4,0.3,0.8,0.8,0.8h3.9v6.6
	C12.6,13.7,12.3,13.9,12,13.9z"
    />
  ),

  healing: () => (
    <path
      id="Path_971"
      d="M24,16l5.6-5.6c0.5-0.5,0.5-1.4,0-2c0,0,0,0,0,0l-6.1-6.1c-0.5-0.5-1.4-0.5-2,0c0,0,0,0,0,0L16,8l-5.6-5.6
	C10.1,2.1,9.8,2,9.4,2c-0.4,0-0.7,0.1-1,0.4L2.4,8.5c-0.5,0.5-0.5,1.4,0,2c0,0,0,0,0,0L7.9,16l-5.6,5.6c-0.5,0.5-0.5,1.4,0,2
	c0,0,0,0,0,0l6.1,6.1c0.5,0.5,1.4,0.5,2,0c0,0,0,0,0,0l5.6-5.6l5.6,5.6c0.3,0.3,0.6,0.4,1,0.4c0.4,0,0.7-0.1,1-0.4l6.1-6.1
	c0.5-0.5,0.5-1.4,0-2c0,0,0,0,0,0L24,16z M16,11.8c0.8,0,1.4,0.6,1.4,1.4c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4l0,0
	C14.6,12.4,15.2,11.8,16,11.8z M9.4,14.5L4.3,9.5l5.1-5.1l5.1,5.1L9.4,14.5z M13.2,17.4c-0.8,0-1.4-0.6-1.4-1.4s0.6-1.4,1.4-1.4
	c0.8,0,1.4,0.6,1.4,1.4c0,0,0,0,0,0C14.6,16.8,14,17.4,13.2,17.4C13.2,17.4,13.2,17.4,13.2,17.4z M16,20.2c-0.8,0-1.4-0.6-1.4-1.4
	s0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4l0,0C17.4,19.6,16.8,20.2,16,20.2L16,20.2L16,20.2z M18.8,14.6c0.8,0,1.4,0.6,1.4,1.4
	c0,0.8-0.6,1.4-1.4,1.4s-1.4-0.6-1.4-1.4l0,0C17.4,15.2,18,14.6,18.8,14.6L18.8,14.6z M22.5,27.7l-5.1-5.1l5.1-5.1l5.1,5.1
	L22.5,27.7z"
    />
  ),

  star: () => (
    <path
      d="M32,12.5h-7.5l5.3-5.3l-5-5l-5.3,5.3V0h-7.1v7.5L7.2,2.2l-5,5l5.3,5.3H0v7.1h7.5l-5.3,5.3l5,5l5.3-5.3V32h7.1v-7.5l5.3,5.3
	l5-5l-5.3-5.3H32V12.5z"
    />
  ),

  filter: () => (
    <path
      d="M14,22c-0.2,0-0.3,0-0.4-0.1l-4-2C9.2,19.7,9,19.4,9,19v-6.2L1.2,3.6C1,3.3,0.9,2.9,1.1,2.6C1.3,2.2,1.6,2,2,2h20
	c0.4,0,0.7,0.2,0.9,0.6s0.1,0.8-0.1,1.1L15,12.8V21c0,0.3-0.2,0.7-0.5,0.9C14.4,22,14.2,22,14,22z M11,18.4l2,1v-6.9
	c0-0.2,0.1-0.5,0.2-0.6L19.8,4H4.2l6.6,7.8c0.2,0.2,0.2,0.4,0.2,0.6V18.4z"
    />
  ),

  category: () => (
    <path
      d="M20,22H4c-1.7,0-3-1.3-3-3V5c0-1.7,1.3-3,3-3h5c0.3,0,0.6,0.2,0.8,0.4L11.5,5H20c1.7,0,3,1.3,3,3v11C23,20.7,21.7,22,20,22z
	 M4,4C3.4,4,3,4.4,3,5v14c0,0.6,0.4,1,1,1h16c0.6,0,1-0.4,1-1V8c0-0.6-0.4-1-1-1h-9c-0.3,0-0.6-0.2-0.8-0.4L8.5,4H4z"
    />
  ),

  cartLarge: () => (
    <path
      d="M21.5,44c0,1.9-1.6,3.5-3.5,3.5s-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5S21.5,42.1,21.5,44z M40,40.5c-1.9,0-3.5,1.6-3.5,3.5
	s1.6,3.5,3.5,3.5s3.5-1.6,3.5-3.5S41.9,40.5,40,40.5z M47.5,14.3l-3.2,16.8c-0.5,2.6-2.8,4.4-5.4,4.4c0,0-0.1,0-0.1,0H19.4
	c0,0-0.1,0-0.1,0c-2.6,0-4.9-1.8-5.4-4.4l-3.3-16.7c0,0,0-0.1,0-0.1L8.8,5.5H2C1.2,5.5,0.5,4.8,0.5,4S1.2,2.5,2,2.5h8
	c0.7,0,1.3,0.5,1.5,1.2l1.8,8.8H46c0.4,0,0.9,0.2,1.2,0.5C47.4,13.4,47.6,13.8,47.5,14.3z M44.2,15.5H13.8l3,15c0.2,1.2,1.3,2,2.5,2
	c0,0,0,0,0,0h19.5c0,0,0,0,0.1,0c1.2,0,2.2-0.8,2.5-2L44.2,15.5z"
    />
  ),
  freeDel: () => (
    <path
      d="M24,48C10.8,48,0,37.2,0,24S10.8,0,24,0s24,10.8,24,24S37.2,48,24,48z M24,3C12.4,3,3,12.4,3,24c0,11.6,9.4,21,21,21
	c11.6,0,21-9.4,21-21C45,12.4,35.6,3,24,3z M22.4,30.1l10.6-10c0.6-0.6,0.6-1.5,0.1-2.1c-0.6-0.6-1.5-0.6-2.1-0.1l-9.5,9l-4.4-4.5
	c-0.6-0.6-1.5-0.6-2.1,0c-0.6,0.6-0.6,1.5,0,2.1l5.4,5.5c0.3,0.3,0.7,0.5,1.1,0.5C21.8,30.5,22.1,30.4,22.4,30.1z"
    />
  ),
};

function SvgIcon({
  icon,
  className,
  viewBox = '0 0 24 24',
  fill,
  cursor,
  title = '',
  alt = '',
  marginLeft = 0,
  width = 24,
  height = 24,
  marginRight = 0,
  onClick = null,
  rotate,
}: Props) {
  const IconSrc: any = icons[icon];

  return (
    <IconWrapper
      cursor={cursor}
      fill={fill}
      className={className}
      viewBox={viewBox}
      onClick={onClick}
      marginLeft={marginLeft}
      marginRight={marginRight}
      width={width}
      height={height}
      rotate={rotate}
    >
      <title id="idTitle">{title}</title>
      <desc id="idDesc">{alt}</desc>
      <IconSrc />
    </IconWrapper>
  );
}

const IconStyles = css`
  vertical-align: middle;
`;

const IconWrapper = styled.svg<{
  fill?: string;
  cursor?: string;
  marginLeft: number;
  marginRight: number;
  width: number;
  height: number;
  rotate?: number;
}>`
  ${IconStyles};
  fill: ${({ theme, fill }) => (fill ? fill : theme.colors.primary)};
  cursor: ${({ cursor }) => (cursor ? cursor : 'initial')};
  transition: fill 0.2s ease, transform 0.2s ease;
  margin-left: ${props => rem(props.marginLeft)};
  margin-right: ${props => rem(props.marginRight)};
  width: ${props => rem(props.width)};
  height: ${props => rem(props.height)};
  transform: ${({ rotate }) => (rotate ? `rotate(${rotate}deg)` : 'none')};
`;

const IconPath = styled.path``;

export { SvgIcon };
